import React from "react";
import {Prompt, Link} from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import {Scrollbars} from "react-custom-scrollbars";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import {Delete as DeleteIcon, FileCopy as CopyIcon} from "@material-ui/icons";
import SaveButton from "../../components/SaveButton";
import noty from "../../lib/noty";
import autoBind from "react-autobind";
import feathers from "../../feathers";
import "./style.scss";

export class Panel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canAdd: true
    };
    autoBind(this);
  }

  componentDidMount() {
    /*
      We check for the users current allowed resources per resource, which is passed in the `checkCanAdd` prop.
      `checkCanAdd` can be an array of resource name strings, a single string, or an empty array.
      It would be ideal to disable the forms until this prop has been checked,
      but, since the latency is marginal, this works for now.
      This logic is also duplicated in the `NewFacility` component as that does not use a `Panel`.
    */
    const {checkCanAdd} = this.props;
    if (checkCanAdd) {
      feathers
        .service("api/allowed-resources")
        .find({query: {scope: checkCanAdd}})
        .then(res => {
          const canAdd = Object.values(res).reduce((canAdd, item) => {
            return canAdd && item.can_add;
          }, true);
          this.setState({canAdd});
        })
        .catch(err => {
          noty.errors(err);
        });
    }
  }

  render() {
    const {onSaveClick, onDeleteClick, onCopyClick, saveTitle, touched, touchedMessage, fetching} = this.props;
    const hasIcons = onDeleteClick;
    const hasSave = onSaveClick && saveTitle;
    return (
      <div style={{position: "relative"}}>
        {touched && touchedMessage && <Prompt when={touched} message={touchedMessage} />}
        <Paper>
          <div className={`container-paper panel ${hasSave && "has-save"} ${hasIcons && "has-icons"}`}>
            {this.state.canAdd && (
              <form onSubmit={onSaveClick}>
                {[this.props.children]}
                {onDeleteClick && (
                  <Tooltip title="Delete" placement="right-start">
                    <IconButton onClick={onDeleteClick} disabled={fetching}>
                      <DeleteIcon style={{color: "#999"}} />
                    </IconButton>
                  </Tooltip>
                )}
                {onCopyClick && (
                  <Tooltip title="Duplicate" placement="right-start">
                    <IconButton onClick={onCopyClick} disabled={fetching}>
                      <CopyIcon style={{color: "#999"}} />
                    </IconButton>
                  </Tooltip>
                )}
                {fetching && (
                  <div className="panel-loader">
                    <LinearProgress mode="indeterminate" />
                  </div>
                )}
                {onSaveClick && saveTitle && (
                  <SaveButton onClick={onSaveClick} title={saveTitle} disabled={fetching} type="submit" />
                )}
              </form>
            )}
            {!this.state.canAdd && (
              <div style={{textAlign: "center"}}>
                <h3>You have exceeded your limit of allowed {this.props.checkCanAdd.toUpperCase()}</h3>
                <br />
                <Link to="/account/settings">
                  <Button variant="contained" fullWidth color="primary">
                    Click here to change your plan
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </Paper>
      </div>
    );
  }
}

// The PanelContainer holds a ScrollBars component, which must have
// its height set. In order to do this at dynamic heights
// well (because the autoHeight prop doesn't really work
// within postion: anbsolute) we need to get the height with each render.
// This is why we use the ref and also why ref={new Date()} to force
// the component render itself again to get the height, because this
// uses children and does not rerender with props
export class PanelContainer extends React.Component {
  render() {
    const {width, open, onToggle, children, hideClose} = this.props;
    return (
      <div
        id="PanelContainer"
        style={{
          // If closed, make width only as wide as the "Close Panel"
          // button. This ensures maximum sraggable area on map and also
          // ensure user can touch map type buttons
          maxWidth: open ? width : 170,
          maxHeight: "100vh"
        }}>
        {open ? (
          <Scrollbars
            autoHeight
            autoHeightMin={0}
            autoHeightMax={"calc(100vh - 56px)"}
            renderThumbVertical={props => <div {...props} className="thumb-vertical" />}
            renderTrackVertical={({style, ...props}) => (
              <div {...props} className="track-vertical" style={{...style, width: 8}} />
            )}>
            <div className="scroll-inner">
              <div className="container-fluid">
                <div className="animated fadeIn">
                  {[children]}
                  {!hideClose && onToggle && (
                    <div>
                      <Button color="secondary" variant="contained" onClick={onToggle} style={{marginTop: 15}}>
                        Close Panel
                      </Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Scrollbars>
        ) : (
          <div style={{padding: "16px 24px"}}>
            <Button variant="contained" onClick={onToggle}>
              Open Panel
            </Button>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Panel/index.jsx